module.exports = __webpack_public_path__ + "img/30.efa68c4c.svg";